<template>
  <section
    class="flex flex-col items-center gap-300"
    :class="{ outlined, 'mx-300': hasHorizontalMargin }"
  >
    <div
      v-if="$slots.headline || $slots.subtitle"
      class="headline-container flex flex-col items-center w-full"
      :class="smallerHeadlineSpacing ? 'gap-050' : 'gap-200'"
    >
      <h1 class="headline-h4-headline">
        <slot name="headline" />
      </h1>
      <p class="subtitle text-center"><slot name="subtitle" /></p>
    </div>

    <Illustration :name="illustration" />

    <slot name="description" />

    <LcButton v-if="$slots.cta && to" v-bind="{ to }">
      <slot name="cta" />
    </LcButton>

    <slot />
  </section>
</template>

<script lang="ts" setup>
// UNIFY IN SF-4105
import type { LcButtonProps } from '@lottocom/frontend-components'

import type { IllustrationProps } from '~/components/Illustration/Illustration.vue'

type VerificationIllustratedSectionProps = {
  hasHorizontalMargin?: boolean
  illustration: IllustrationProps['name']
  outlined?: boolean
  smallerHeadlineSpacing?: boolean
  to?: LcButtonProps['to']
}

const { hasHorizontalMargin = true, smallerHeadlineSpacing = false } =
  defineProps<VerificationIllustratedSectionProps>()
</script>

<style lang="scss" scoped>
.subtitle {
  max-width: calc($main-content-width / 2);
}

.outlined {
  padding: 1.5rem 1rem;
  border: token('size/border/100') token('color/border/primary/primary') solid;
  border-radius: 1rem;
}
</style>
